import { render, staticRenderFns } from "./DiscountLimitEditModal.vue?vue&type=template&id=aec2cb64&scoped=true&"
import script from "./DiscountLimitEditModal.vue?vue&type=script&lang=js&"
export * from "./DiscountLimitEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec2cb64",
  null
  
)

export default component.exports